export const PRIVACYPOLICY_CMS_DATA = 'PRIVACYPOLICY_CMS_DATA';
export const SHOW_LOADER = 'SHOW_LOADER';
